// src/utils/auth.js
export function isTokenExpired(token) {
  // If no token is provided, check localStorage
  const checkToken = token || localStorage.getItem("user_token");

  if (!checkToken) return true;

  try {
    // Basic JWT decoding (header.payload.signature)
    const parts = checkToken.split(".");
    if (parts.length !== 3) {
      // Not a standard JWT, fallback to "exists = valid"
      return false;
    }

    // Use a URL-safe base64 decode if possible, but atob is usually enough for data
    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join(""),
    );

    const payload = JSON.parse(jsonPayload);
    if (!payload.exp) {
      return false;
    }

    const currentTime = Math.floor(Date.now() / 1000);
    const expired = payload.exp < currentTime;

    if (expired) {
      console.warn("[Auth] Token expired at:", new Date(payload.exp * 1000));
    }

    return expired;
  } catch (e) {
    // console.error("[Auth] Error parsing token for expiration:", e);
    return false;
  }
}
